import React, { FunctionComponent, useEffect } from "react";
import useResizeObserver from "use-resize-observer";
import { useSyncLocalStore } from "designSystem/hooks";
import ColorChipArrayStore, { ColorChipArrayStoreContext, ColorSpec } from "./ColorChipArrayStore";
import ColorChipArrayInternal, { ColorChipArrayInternalCallbackProps } from "./ColorChipArrayInternal";

export interface ColorChipArrayProps extends ColorChipArrayInternalCallbackProps {
	/** list of colors (images) to show */
	colors: ColorSpec[];

	/** default color chip to add to front of the list */
	defaultColor?: ColorSpec;

	/** selected color */
	value?: ColorSpec;
}

export const ColorChipArray: FunctionComponent<ColorChipArrayProps> = (props) => {
	const { colors, defaultColor, onSelectChip, onMouseEnterChip, onMouseLeaveChip, value } = props;

	if (!defaultColor && !colors.length) {
		return null;
	}

	const store = useSyncLocalStore(() => new ColorChipArrayStore(colors, defaultColor, value));

	// need to update the width as resizing
	const { ref } = useResizeObserver<HTMLDivElement>({
		onResize: ({ width }) => store.setWidth(width),
	});

	useEffect(() => {
		store.setValue(value);
		store.setColors(colors);
	}, []);

	return (
		<ColorChipArrayStoreContext.Provider value={store}>
			<div ref={ref}>
				<ColorChipArrayInternal
					onMouseEnterChip={onMouseEnterChip}
					onMouseLeaveChip={onMouseLeaveChip}
					onSelectChip={onSelectChip}
				/>
			</div>
		</ColorChipArrayStoreContext.Provider>
	);
};

export default ColorChipArray;